import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      <p class="poem-block text-center mb-3">* * *</p>
      

      <p class="poem-block mb-3">
      Белый закат. Чёрный рассвет.<br/>
      Пути для меня больше нет.<br/>
      Чёрный рассвет. Белый закат.<br/>
      Кто мне на свете друг и брат?<br/>
      Нет никого. Я иду одна.<br/>
      Нужно выпить чашу до дна.
      </p>
      
    </div>
    `
  )
}

const itemDate = {
  rus: 'Июль 2007'
}

const itemName = {
  rus: 'Белый закат. Черный рассвет.'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;